import React from 'react'
import './Services.css'
import { GrFormClose } from 'react-icons/gr'
import { HiBadgeCheck } from 'react-icons/hi'
import { useState } from 'react'
import { MdOutlineScreenshotMonitor } from 'react-icons/md'
import { FiCode } from 'react-icons/fi'
import { HiOutlineLightBulb } from 'react-icons/hi'
import { AiOutlineArrowRight } from 'react-icons/ai'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const Services = () => {


  const { ref, inView } = useInView({
    threshold: 0.3, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const topVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };

  const linkVariants = {
    hidden : { opacity:0 , y: 0 },
    visible: { opacity: 1, y: 0, transition: { duration: 1} }
  };



  

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView, animation]);





















  const [ openModal , setOpenModal ] = useState(0);

  const openmodal = (modal) => {
    setOpenModal(modal);
  }






  return (
    <section id='Services'>
      <div ref={ref} >
      <motion.div variants={topVariants} 
          initial="hidden"
          animate={animation} className='services__div'>
      <h5 className='services__h5'>services</h5>
      <h2 className='hire__me'>Hire Me !!</h2>
      </motion.div>
      <div className="container services__container">
        <div className="services__content">
          <div  variants={linkVariants} 
          initial="hidden"
          animate={animation} className="service__web">
            <MdOutlineScreenshotMonitor className='cg__web'/>
            <h2>web development</h2>
            <p className='head__p'>developing the webpage according to the customer needs</p>
            <button className="services__btn" onClick={() => openmodal(1)}>view more <AiOutlineArrowRight className='right_ai'/></button>

          </div>
          <div className={openModal === 1 ? "services__modal active-modal" : "services__modal"}>



              <div className="services__modal-content">


                <GrFormClose onClick={() => openmodal(0)} className="services__modal-close"/>


                <h3 className="services__modal-title">Web Developer</h3>
                <p className= "modal-p">i have been in webdevelopment for 2 years . completed many web projects </p>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>i have been in webdevelopment for 2 years</p >
                </div>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>i completed doing many projects</p >
                </div>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>i use html, css, javascript, reactjs</p >
                </div>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>i do with very good perfection</p >
                </div>


              </div>
</div>






          <div variants={linkVariants} 
          initial="hidden"
          animate={animation} className="service__web">
            <FiCode className='cg__web'/>
            <h2>web design</h2>
            <p className='head__p'>developing the webpage according to the customer needs</p>
            <button className="services__btn" onClick={() => openmodal(2)}>view more <AiOutlineArrowRight className='right_ai'/></button>





          </div>



          <div className={openModal === 2 ? "services__modal active-modal" : "services__modal"}>



<div className="services__modal-content">


  <GrFormClose onClick={() => openmodal(0)} className="services__modal-close"/>


  <h3 className="services__modal-title">Web Design</h3>
  <p className= "modal-p">i have been webdesigning since 1.5 years . completed many web projects </p>
  <div className="services__modal-services">
    <HiBadgeCheck className='services__modal-icon'/>
    <p className='modal__p'>i have been doing webdesigns for 2 years</p >
  </div>
  <div className="services__modal-services">
    <HiBadgeCheck className='services__modal-icon'/>
    <p className='modal__p'>i use figma for webdesigns</p >
  </div>
  <div className="services__modal-services">
    <HiBadgeCheck className='services__modal-icon'/>
    <p className='modal__p'>i have made many designs</p >
  </div>
  <div className="services__modal-services">
    <HiBadgeCheck className='services__modal-icon'/>
    <p className='modal__p'>i tried to get best webdesigns </p >
  </div>


</div>
</div>


















          <div variants={linkVariants} 
          initial="hidden"
          animate={animation} className="service__web">
            <HiOutlineLightBulb className='cg__web'/>
            <h2>creative ideas</h2>
            <p className='head__p'>developing the webpage according to the customer needs</p>
            <button className="services__btn" onClick={() => openmodal(3)}>view more <AiOutlineArrowRight className='right_ai'/></button>




            




          </div>


          <div className={openModal === 3 ? "services__modal active-modal" : "services__modal"}>



              <div className="services__modal-content">


                <GrFormClose onClick={() => openmodal(0)} className="services__modal-close"/>


                <h3 className="services__modal-title">Creative Idea's</h3>
                <p className= "modal-p">i have some really amazing ideas of how the website to be built</p>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>i have some of the good ideas </p>
                </div>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>i implemented some of my creative ideas in website building</p >
                </div>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>check out some amazing ideas </p >
                </div>
                <div className="services__modal-services">
                  <HiBadgeCheck className='services__modal-icon'/>
                  <p className='modal__p'>i have been implementing  these ideas since an year</p >
                </div>


              </div>
            </div>

        </div>
        
      </div>
      </div>

    </section>
  )
}

export default Services